import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/logo.png";
import { solutionsContent } from "../../assets/data/contentData";

const Header = ({ activeSolId, onSolChange }) => {
  const [scroll,    setScroll]    = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [isMobile,  setIsMobile]  = useState(window.innerWidth < 992);
  const menuRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const close = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [menuOpen]);

  const handleLogin = () => { window.location.href = "https://ikhnuden.intellx.mn"; };

  const handleSolChange = (id) => { onSolChange(id); setMenuOpen(false); };

  const activeColor = solutionsContent[activeSolId]?.color || "#5C27FE";

  return (
    <>
      <style>{`
        @keyframes menuSlideDown {
          from { opacity:0; transform:translateY(-8px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .hdr-drop-item:hover { background: rgba(255,255,255,0.06) !important; }
      `}</style>

      <header style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100,
        transition: "all 0.5s cubic-bezier(0.4,0,0.2,1)",
        background: scroll ? "rgba(7,10,41,0.95)" : "transparent",
        backdropFilter: scroll ? "blur(30px)" : "none",
        borderBottom: scroll ? "1px solid rgba(255,255,255,0.08)" : "1px solid transparent",
        padding: "0 20px",
      }}>
        <div style={{
          maxWidth: "1440px", margin: "0 auto",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          height: scroll ? "70px" : "90px", transition: "height 0.4s ease",
        }}>

          {/* Logo */}
          <Link to="/" style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            <img src={logo} alt="INTELLX" style={{ height: scroll ? "28px" : "32px", transition: "height 0.3s" }} />
          </Link>

          {/* Desktop nav */}
          {!isMobile && (
            <nav style={{ display: "flex", gap: "5px", flex: 1, justifyContent: "center" }}>
              {Object.values(solutionsContent).map((s) => (
                <button
                  key={s.id}
                  onClick={() => onSolChange(s.id)}
                  style={{
                    padding: "10px 18px", background: "transparent", border: "none",
                    color: activeSolId === s.id ? "#fff" : "rgba(255,255,255,0.4)",
                    cursor: "pointer", fontSize: "10px", fontFamily: "'Conthrax', sans-serif",
                    letterSpacing: "1.2px", transition: "all 0.3s",
                    textTransform: "uppercase", position: "relative",
                  }}
                >
                  {s.brand}
                  {activeSolId === s.id && (
                    <div style={{
                      position: "absolute", bottom: "-5px", left: "20%", right: "20%",
                      height: "2px", background: s.color, boxShadow: `0 0 10px ${s.color}`,
                    }} />
                  )}
                </button>
              ))}
            </nav>
          )}

          {/* Right side */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>

            {/* Access Dashboard button — desktop only */}
            {activeSolId === "media" && !isMobile && (
              <button onClick={handleLogin} style={{
                background: "linear-gradient(135deg, #5C27FE, #7C3AED)",
                border: "none", borderRadius: "50px",
                padding: "8px 20px",
                color: "#fff", fontSize: "9px", fontFamily: "'Conthrax', sans-serif",
                cursor: "pointer", boxShadow: "0 8px 20px rgba(92,39,254,0.4)",
                whiteSpace: "nowrap",
              }}>
                ACCESS DASHBOARD →
              </button>
            )}

            {/* Hamburger — mobile/tablet only */}
            {isMobile && (
              <div ref={menuRef} style={{ position: "relative" }}>
                <button
                  onClick={() => setMenuOpen((v) => !v)}
                  aria-label="Toggle menu"
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    padding: "8px", display: "flex", flexDirection: "column",
                    gap: "5px", alignItems: "center", justifyContent: "center",
                  }}
                >
                  {/* SVG hamburger / X icon */}
                  <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {menuOpen ? (
                      <>
                        <line x1="1" y1="1"  x2="21" y2="15" stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="21" y1="1" x2="1"  y2="15" stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinecap="round"/>
                      </>
                    ) : (
                      <>
                        <line x1="0" y1="1"  x2="22" y2="1"  stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="0" y1="8"  x2="22" y2="8"  stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="0" y1="15" x2="22" y2="15" stroke="rgba(255,255,255,0.85)" strokeWidth="2" strokeLinecap="round"/>
                      </>
                    )}
                  </svg>
                </button>

                {menuOpen && (
                  <div style={{
                    position: "absolute", top: "calc(100% + 10px)", right: 0,
                    minWidth: "230px", zIndex: 1200,
                    background: "rgba(7,10,41,0.97)",
                    backdropFilter: "blur(30px)",
                    border: "1px solid rgba(255,255,255,0.10)",
                    borderRadius: "14px", overflow: "hidden",
                    animation: "menuSlideDown 0.22s ease both",
                    boxShadow: `0 20px 60px rgba(0,0,0,0.6), 0 0 0 1px ${activeColor}20`,
                  }}>
                    {Object.values(solutionsContent).map((s, i) => (
                      <button
                        key={s.id}
                        className="hdr-drop-item"
                        onClick={() => handleSolChange(s.id)}
                        style={{
                          display: "flex", alignItems: "center", gap: "12px",
                          width: "100%", padding: "15px 20px",
                          background: activeSolId === s.id ? `${s.color}18` : "transparent",
                          border: "none",
                          borderTop: i === 0 ? "none" : "1px solid rgba(255,255,255,0.05)",
                          color: activeSolId === s.id ? s.color : "rgba(255,255,255,0.55)",
                          fontSize: "9px", fontFamily: "'Conthrax', sans-serif",
                          letterSpacing: "1.5px", textTransform: "uppercase",
                          cursor: "pointer", textAlign: "left",
                        }}
                      >
                        <div style={{
                          width: "5px", height: "5px", borderRadius: "50%", flexShrink: 0,
                          background: activeSolId === s.id ? s.color : "rgba(255,255,255,0.15)",
                          boxShadow: activeSolId === s.id ? `0 0 8px ${s.color}` : "none",
                        }} />
                        {s.brand}
                      </button>
                    ))}

                    {/* Access Dashboard — media сонгоход dropdown дотор */}
                    {activeSolId === "media" && (
                      <div style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
                        <button
                          onClick={() => { setMenuOpen(false); handleLogin(); }}
                          style={{
                            width: "100%", padding: "12px 16px",
                            background: "linear-gradient(135deg, #5C27FE, #7C3AED)",
                            border: "none", borderRadius: "8px",
                            color: "#fff", fontSize: "9px", fontFamily: "'Conthrax', sans-serif",
                            letterSpacing: "1.5px", textTransform: "uppercase",
                            cursor: "pointer", boxShadow: "0 6px 20px rgba(92,39,254,0.4)",
                          }}
                        >
                          ACCESS DASHBOARD →
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
